<template>
  <article class="queue-up-status-page text-left">
    <v-row justify="center">
      <v-col cols="12"
             sm="12"
             md="4">
        <h3
            class="queue-up-status-page_header font-weight-light"
            v-html="QUEUE_UP_STATUS_DATA.statusText"/>
        <Progressbar :value="QUEUE_UP_STATUS_DATA.progress"
                     class="mt-4"/>
        <Message v-for="(message, i) in QUEUE_UP_STATUS_DATA.messages"
                 :key="i"
                 :message="message"
                 class="mt-4"/>
      </v-col>
    </v-row>
  </article>
</template>

<script>
import {mapGetters} from "vuex";
import Progressbar from "@/components/Progressbar";
import Message from "@/components/Message";


export default {
  name: "Queue-Up-Status-Page",
  components: {Message, Progressbar},
  mounted: function () {
    window.setInterval(() => {
      if (this.$route.name !== 'Status') {
        return;
      }
      this.$store.dispatch('GET_QUEUE_UP_STATUS_DATA', {
        tenantCode: this.$route.params.tenantCode,
        code: this.$route.params.code,
        uuid: this.$route.params.id,
      })
    }, 10000);
  },
  beforeCreate() {
    this.$store.dispatch('GET_QUEUE_UP_STATUS_DATA', {
      tenantCode: this.$route.params.tenantCode,
      code: this.$route.params.code,
      uuid: this.$route.params.id,
    })
  },
  computed: {
    ...mapGetters([
      'QUEUE_UP_STATUS_DATA',
    ])
  },
}
</script>

<style scoped>

</style>
